import * as yup from 'yup';

export const dropdownSchema = yup
  .object()
  .shape({
    label: yup.string().defined('Required'),
    value: yup.mixed().defined('Required'),
  })
  .nullable();
